import React from "react";
import PropTypes from "prop-types";
import { Form as FormikForm, InputField, TextareaField } from "components/common_components/Formik";
import Grid from "@material-ui/core/Grid";
import * as Yup from "yup";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";

function Form({ data, mode, ...rest }) {
    const validationSchema = Yup.object({
        id: Yup.string().required("Required field").max(100, "Max length is 100 characters"),
        issuer: Yup.string().required("Required field").max(200, "Max length is 200 characters"),
        description: Yup.string().notRequired().max(500, "Max length is 500 characters"),
        websiteUrl: Yup.string().notRequired().max(1000, "Max length is 1000 characters"),
    });

    return (
        <FormikForm initialValues={data} validationSchema={validationSchema} {...rest}>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <FormControl component="fieldset">
                        <FormGroup row>
                            <InputField
                                disabled={mode === "update"}
                                fieldName="id"
                                label="Identifier *"
                                uppercase
                                fullWidth={false}
                                maxLength={100}
                            />
                            <InputField fieldName="issuer" label="Issuer *" maxLength={200} />
                            <TextareaField fieldName="description" label="Description" maxLength={500} />
                            <InputField fieldName="websiteUrl" label="Website URL" maxLength={1000} />
                        </FormGroup>
                    </FormControl>
                </Grid>
            </Grid>
        </FormikForm>
    );
}

Form.propTypes = {
    data: PropTypes.shape({
        id: PropTypes.string,
        issuer: PropTypes.string,
        description: PropTypes.string,
        websiteUrl: PropTypes.string,
    }),
    mode: PropTypes.oneOf(["add", "update"]).isRequired,
};

Form.defaultProps = {
    data: {
        id: "",
        issuer: "",
        description: "",
        websiteUrl: "",
    },
};

export default Form;
